const classStatuses = {
  0: 'Pendente',
  1: 'Aceita',
  2: 'Recusada',
  3: 'Cancelada',
  4: 'Cancelada por conflito com outro horário',
  5: 'Não respondida a tempo',
  7: 'Concluída',
}

export default classStatuses
